import { ChartButton, ChartView } from "@icpswap/ui";

export const DefaultChartView: ChartButton = {
  label: "DexTools",
  value: ChartView.DexTools,
};
